import { createSlice } from "@reduxjs/toolkit";
import { getOrders } from "../../reduxApi/admin/OrdersReduxApi";
import { getProductReviewApi, getProductReviewCountApi } from "../../reduxApi/admin/ProductReviewApi";

const AdminProductReviewSlice = createSlice({
  name: "AdminProductReview",
  initialState: {
    status: "idle",
    getProductReview: [],
    getProductReviewCount: [],
  },
  reducers: {
    addProductReviewAction: (state, action) => {
      console.log("get product review action",action);
      state.getProductReview.unshift(action.payload)
    },
    deleteProductReviewAction: (state, action) => {
      action.payload.forEach((id) => {
        const index = state.getProductReview.findIndex((item) => item.ROWID === id);
        if (index !== -1) {
          state.getProductReview.splice(index, 1);
        }
      });
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProductReviewApi.pending, (state, action) => {
        state.status = "pending";
      })
      .addCase(getProductReviewApi.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.getProductReview = action.payload.respon;
        console.log("getProductReview", action.payload);
      })
      .addCase(getProductReviewCountApi.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.getProductReviewCount = action.payload.data.Count;
        console.log("getProductReview", action.payload.data.reviews);
      });
  },
});
export const { deleteProductReviewAction, addProductReviewAction } = AdminProductReviewSlice.actions;
export default AdminProductReviewSlice.reducer;
